import type { Context, ReactElement, ReactNode } from "react";
import { createContext, createElement, useContext, useMemo } from "react";
import {
  type CredentialRecoveryClient,
  HttpCredentialRecoveryClient,
} from "./credential-recovery-client";

const CredentialRecoveryClientContext: Context<CredentialRecoveryClient | undefined> =
  createContext<CredentialRecoveryClient | undefined>(undefined);

let defaultClient: CredentialRecoveryClient | undefined;

function getDefaultClient(): CredentialRecoveryClient {
  defaultClient ??= new HttpCredentialRecoveryClient();
  return defaultClient;
}

export interface CredentialRecoveryClientProviderProps {
  children: ReactNode;
  client?: CredentialRecoveryClient;
}

export function CredentialRecoveryClientProvider({
  children,
  client,
}: CredentialRecoveryClientProviderProps): ReactElement {
  const value = useMemo(() => client ?? getDefaultClient(), [client]);
  return createElement(CredentialRecoveryClientContext.Provider, { value }, children);
}

export function useCredentialRecoveryClient(): CredentialRecoveryClient {
  return useContext(CredentialRecoveryClientContext) ?? getDefaultClient();
}
